import * as React from "react";
import { IconProps } from "../types";

const GridOutlineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <rect
          x="2.75"
          y="2.75"
          width="4.5"
          height="4.5"
          rx="1"
          ry="1"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <rect
          x="10.75"
          y="2.75"
          width="4.5"
          height="4.5"
          rx="1"
          ry="1"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <rect
          x="2.75"
          y="10.75"
          width="4.5"
          height="4.5"
          rx="1"
          ry="1"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <rect
          x="10.75"
          y="10.75"
          width="4.5"
          height="4.5"
          rx="1"
          ry="1"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </svg>
    );
  },
);

export default GridOutlineIcon;
